export default __webpack_public_path__ + "static/media/meet_proj.3f0f741b.png";